import { useStore } from 'vuex'
import { ref, computed } from 'vue'

export default {
    name: "ProfilePicture",
    props: {
        userId: {
            type: String,
            required: true
        },
        content: {
            type: Object,
            required: false,
            default: null
        },
        type: {
            type: String,
            required: true
        },
        hasProfileImage: {
            type: Boolean,
            required: false
        }
    },
    setup(props){
        const store = useStore()

        const showInputErrors = ref(false)
        const isSubmissionError = ref(false)
        const profilePicture = ref(props.content)
        const hasProfileImage = ref(props.hasProfileImage)

        const getLabel = (labelKey, replacements) => {
            let label = store.getters['labels/getLabel']({ labelCollection: 'profilePicture', labelKey: labelKey })
            if (replacements) {
                replacements.forEach((replacement, index) => {
                    label = label.replace(`{${index}}`, replacement)
                })
            }
            return label
        } 

        const onPictureChange = async (e) => {
            try {
                const picture = e.target.files
                Array.from(picture).forEach(file => {
                    profilePicture.value = file
                    profilePicture.value.url = URL.createObjectURL(file)
                })

                setTimeout( ()=> {
                    const deleteButton = document.querySelector('.kb-js--delete-uploaded-file-card')
                    deleteButton.focus()
                } , 100)

                await submitProfilePicture()

                hasProfileImage.value = true
            }
            catch {
                isSubmissionError.value = true
            }
        }

        const removeFile = async () => {
            profilePicture.value = {
                url: props?.content.url
            }
            showInputErrors.value = false
            isSubmissionError.value = false

            setTimeout( ()=> {
                const pictureUploadLabel = document.querySelector('.kb-js--uploaded-file-label')
                pictureUploadLabel.focus()
            } , 100)

            if (props.type == "frivillig") {
                await store.dispatch('frivilligprofil/removeFrivilligProfilePicture')
            }
            else {
                await store.dispatch('forum/removeForumProfilePicture', { id: props.userId })
            }

            const profilePicturePath = profilePicture.value.url ?? props?.content?.url
            const url = new URL(`${window.location.origin}${profilePicturePath}`)
            url.searchParams.append("hasProfileImage", false)
            profilePicture.value = {
                url: url.toString(),
                size: "",
                name: "",
            } 
            
            hasProfileImage.value = false
            store.dispatch('main/setUserProfileImage', profilePicture.value.url)
        }

        const submitProfilePicture = async function () {
            showInputErrors.value = true

            if (profilePicture.value !== "") {
                let formData = new FormData()
                formData.append('file', profilePicture.value)

                if (props.type == "cancerforum") {
                    store.dispatch('forum/submitForumProfilePicture', {
                        formData: formData,
                        id: props.userId
                    })
                }
                if (props.type == "frivillig") {
                    store.dispatch('frivilligprofil/submitFrivilligProfilePicture', {
                        formData: formData,
                        id: props.userId
                    })
                }

                store.dispatch('main/setUserProfileImage', profilePicture.value.url ?? props?.content?.url)
            }   
        }

        const handleTab = function (e) {
            const fileInput = e.target.querySelector('input')
            fileInput.click()

        }

        return {
            handleTab,
            getLabel,
            submitProfilePicture,
            onPictureChange,
            removeFile,
            hasProfileImage,
            profilePicture,
            showInputErrors,
            isSubmissionError
        }     
    }
}